"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHanAccessDetails = exports.getContracts = exports.getContractConsumptions = exports.getContractConsumptionDetails = exports.getContractAdditionalDetails = exports.default = void 0;
var _contractApi = _interopRequireDefault(require("../csc/api/contractApi"));
var _contractApi2 = _interopRequireDefault(require("../cic/api/contractApi"));
var _mainConfig = require("../mainConfig");
var currentApiSet = _mainConfig.isCICContentTree ? _contractApi2.default : _contractApi.default;
var getContracts = exports.getContracts = currentApiSet.getContracts,
  getHanAccessDetails = exports.getHanAccessDetails = currentApiSet.getHanAccessDetails,
  getContractAdditionalDetails = exports.getContractAdditionalDetails = currentApiSet.getContractAdditionalDetails,
  getContractConsumptionDetails = exports.getContractConsumptionDetails = currentApiSet.getContractConsumptionDetails,
  getContractConsumptions = exports.getContractConsumptions = currentApiSet.getContractConsumptions;
var _default = exports.default = currentApiSet;